export default __webpack_public_path__ + "static/media/3.9d946753.png";